import { render, staticRenderFns } from "./YearSelector.vue?vue&type=template&id=0966edbc"
import script from "./YearSelector.vue?vue&type=script&lang=js"
export * from "./YearSelector.vue?vue&type=script&lang=js"
import style0 from "./YearSelector.vue?vue&type=style&index=0&id=0966edbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports